export default "__VITE_ASSET__750a88bd__"